import React, { useState, useEffect, useMemo } from 'react';
import axios, { AxiosRequestConfig } from 'axios';

import useTranslations from '@/hooks/useTranslations';
import DangerouslySetHtmlContent from '@/components/DangerouslySetHtmlContent';
import { Locales } from '@/types/Locales';

type Props = {
  id: string;
  lang: Locales;
};

const ENGAGE_ENDPOINT = 'https://keytradebank.slgnt.eu/optiext/optiextension.dll';

const AXIOS_OPTIONS: Partial<AxiosRequestConfig> = {
  headers: { Accept: 'text/html' },
};

const EngageContentRenderer: React.FC<Props> = (props) => {
  const { id, lang } = props;

  const { t } = useTranslations();
  const [headContent, setHeadContent] = useState('');
  const [bodyContent, setBodyContent] = useState('');

  const engageUrl = useMemo(() => {
    if (typeof window === 'undefined') {
      return ENGAGE_ENDPOINT;
    }

    const urlSearchParams = new URLSearchParams();
    const currentQueryParams = new URLSearchParams(window.location.search);

    for (const [key, value] of Array.from(currentQueryParams.entries())) {
      urlSearchParams.set(key, value);
    }

    urlSearchParams.set('ID', id);
    urlSearchParams.set('LANG', lang);

    return `${ENGAGE_ENDPOINT}?${urlSearchParams.toString()}`;
  }, [id, lang]);

  useEffect(() => {
    const getMarketingMessage = async () => {
      try {
        const response = await axios.get(engageUrl, AXIOS_OPTIONS);
        const { data } = response;

        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data.trim(), 'text/html');

        setHeadContent(htmlDoc.head.innerHTML);
        setBodyContent(htmlDoc.body.innerHTML);
      } catch (error) {
        setBodyContent(`
          <div style="font-size: 2rem; display: flex; justify-content: center; align-items: center; padding: 2rem 0;">
            ${t('generic_error')}
          </div>
        `);
      }
    };

    if (id) {
      getMarketingMessage();
    }
  }, [id, engageUrl]);

  useEffect(() => {
    if (headContent) {
      const headFragment = document
        .createRange()
        .createContextualFragment(headContent);

      document.head.appendChild(headFragment);
    }
  }, [headContent]);

  return <DangerouslySetHtmlContent html={bodyContent} />;
};

export default EngageContentRenderer;
